module.exports = __webpack_public_path__ + "static/media/two-flavors-pizza.acf6aa28.svg";